module.exports = __webpack_public_path__ + "img/banner9.3639b4b1.jpg";